import { defineAsyncComponent } from 'vue';
import iconoItinerario from '@/assets/icons/builder/itinerario.svg';
import iconoArtistas from '@/assets/icons/builder/musica.svg';
import iconoAsistentes from '@/assets/icons/builder/assistants.svg';
import iconoContacto from '@/assets/icons/builder/contacto.svg';
import iconoFormulario from '@/assets/icons/builder/formulario.svg';
import iconoImagenes from '@/assets/icons/builder/imagenes.svg';
import iconoImagenesYTexto from '@/assets/icons/builder/imagenes-texto.svg';
import iconoVideo from '@/assets/icons/builder/video.svg';
import iconoPatrocinadores from '@/assets/icons/builder/patrocinadores.svg';
import iconoPreguntasFrecuentes from '@/assets/icons/builder/preguntasFrecuentes.svg';
import iconoTexto from '@/assets/icons/builder/texto.svg';
import iconoAdjuntos from '@/assets/icons/builder/archivosAdjuntos.svg';
import iconoAlojamientos from '@/assets/icons/builder/alojamientos.svg';
import iconoRedesSociales from '@/assets/icons/builder/redes-sociales.svg';
import iconoCalendario from '@/assets/icons/builder/calendar.svg';
import iconoCuentaAtras from '@/assets/icons/builder/cuenta-atras.svg';
import iconoFaq from '@/assets/icons/builder/faq.svg';
import iconoUbicaciones from '@/assets/icons/builder/location.svg';
import iconoDatosBasicos from '@/assets/icons/builder/datosbasicos.svg';
import iconoExperiencias from '@/assets/icons/builder/experiencias.svg';
import iconoServicios from '@/assets/icons/builder/servicios.svg';
import iconoPagos from '@/assets/icons/builder/pagosyplazos.svg';
import iconoTerminos from '@/assets/icons/builder/terminosycondiciones.svg';
import iconoSeparador from '@/assets/icons/builder/separador.svg';
import iconoVuelos from '@/assets/icons/builder/vuelos.svg';
import iconoServiciosExtra from '@/assets/icons/builder/extraservices.svg';
import iconoServiciosObligatorios from '@/assets/icons/builder/mandatory.svg';
import iconoAgrupaciones from '@/assets/icons/builder/agrupaciones.svg';
import iconoBanner from '@/assets/icons/raw/banner.svg';
import i18n from '@/i18n';

export const DESIGN_A = 'DESIGN_A';
export const DESIGN_B = 'DESIGN_B';
export const DESIGN_C = 'DESIGN_C';
export const DESIGN_D = 'DESIGN_D';
export const DESIGN_E = 'DESIGN_E';

export const DISPOSITIVO = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const ENTITY_TYPES = {
  VIAJE: 'viaje',
  AGRUPACION: 'agrupacion',
  PAGINA: 'pagina',
};

export const BLOCK_TYPES = {
  SUMMARY: 'summary',
  EXPERIENCES: 'experiences',
  SERVICES: 'services',
  PAYMENTS: 'payments',
  TERMS: 'termsAndConditions',
  TEXT: 'text',
  ITINERARY: 'itinerary',
  IMAGES: 'images',
  VIDEO: 'video',
  IMAGES_AND_TEXT: 'imagesAndText',
  FILES: 'files',
  SPONSORS: 'sponsors',
  ACCOMMODATIONS: 'accommodations',
  ARTISTS: 'artists',
  CONTACT: 'contact',
  SOCIAL_MEDIA: 'socialMedia',
  INDEX: 'index',
  ATTENDEES: 'attendees',
  GROUPINGS: 'agrupaciones',
  BANNER: 'banner',
  FORM: 'form',
  LOCATIONS: 'locations',
  FAQS: 'faqs',
  CALENDAR: 'calendar',
  COUNTDOWN: 'countdown',
  FAQ: 'faq',
  SEPARATOR: 'separator',
  FLIGHTS: 'flight',
  MANDATORY_SERVICES: 'mandatoryServices',
  EXTRA_SERVICES: 'extraServices',
};

export function getIconBlock(builderType) {
  const blockTypeToIcon = {
    [BLOCK_TYPES.FILES]: iconoAdjuntos,
    [BLOCK_TYPES.ARTISTS]: iconoArtistas,
    [BLOCK_TYPES.ATTENDEES]: iconoAsistentes,
    [BLOCK_TYPES.CONTACT]: iconoContacto,
    [BLOCK_TYPES.FORM]: iconoFormulario,
    [BLOCK_TYPES.ITINERARY]: iconoItinerario,
    [BLOCK_TYPES.IMAGES]: iconoImagenes,
    [BLOCK_TYPES.IMAGES_AND_TEXT]: iconoImagenesYTexto,
    [BLOCK_TYPES.LOCATIONS]: iconoUbicaciones,
    [BLOCK_TYPES.VIDEO]: iconoVideo,
    [BLOCK_TYPES.SPONSORS]: iconoPatrocinadores,
    [BLOCK_TYPES.ACCOMMODATIONS]: iconoAlojamientos,
    [BLOCK_TYPES.TEXT]: iconoTexto,
    [BLOCK_TYPES.FAQS]: iconoPreguntasFrecuentes,
    [BLOCK_TYPES.SOCIAL_MEDIA]: iconoRedesSociales,
    [BLOCK_TYPES.CALENDAR]: iconoCalendario,
    [BLOCK_TYPES.COUNTDOWN]: iconoCuentaAtras,
    [BLOCK_TYPES.FAQ]: iconoFaq,
    [BLOCK_TYPES.SUMMARY]: iconoDatosBasicos,
    [BLOCK_TYPES.EXPERIENCES]: iconoExperiencias,
    [BLOCK_TYPES.SERVICES]: iconoServicios,
    [BLOCK_TYPES.PAYMENTS]: iconoPagos,
    [BLOCK_TYPES.TERMS]: iconoTerminos,
    [BLOCK_TYPES.SEPARATOR]: iconoSeparador,
    [BLOCK_TYPES.FLIGHTS]: iconoVuelos,
    [BLOCK_TYPES.MANDATORY_SERVICES]: iconoServiciosObligatorios,
    [BLOCK_TYPES.EXTRA_SERVICES]: iconoServiciosExtra,
    [BLOCK_TYPES.BANNER]: iconoBanner,
    [BLOCK_TYPES.GROUPINGS]: iconoAgrupaciones,
  };

  return blockTypeToIcon[builderType] || iconoTexto;
}

const DEFAULT_TITLE_BLOCK_TYPES = [BLOCK_TYPES.SUMMARY];

const asyncBlockComponentCache = new Map();

export function getNombreBlock(builder) {
  if (DEFAULT_TITLE_BLOCK_TYPES.includes(builder.tipo)) {
    return i18n.global.t(`builder.title.${builder.tipo}`);
  }
  return builder.nombre;
}

export function hasNombreBlock(builder) {
  return DEFAULT_TITLE_BLOCK_TYPES.includes(builder.tipo) || !!builder.nombre?.trim();
}

export function getBlockComponent(tipo, dispositivo = DISPOSITIVO.DESKTOP, entityType = ENTITY_TYPES.VIAJE) {
  const cacheKey = `${tipo}|${dispositivo}|${entityType}`;
  if (asyncBlockComponentCache.has(cacheKey)) return asyncBlockComponentCache.get(cacheKey);

  const blockComponents = {
    [BLOCK_TYPES.SUMMARY]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/SummaryViajeBlockDesktop.vue'),
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/SummaryAgrupacionBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/SummaryViajeBlockMobile.vue'),
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/SummaryAgrupacionBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.EXPERIENCES]: {
      [DISPOSITIVO.DESKTOP]: () =>
        import('@/views/productos/informacion/builder/ExperiencesAgrupacionBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ExperiencesAgrupacionBlockMobile.vue'),
    },
    [BLOCK_TYPES.SERVICES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ServicesBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ServicesBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.MANDATORY_SERVICES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/MandatoryServicesBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/MandatoryServicesBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.EXTRA_SERVICES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ExtraServicesBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ExtraServicesBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.TEXT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/TextBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/TextBlockMobile.vue'),
    },
    [BLOCK_TYPES.ITINERARY]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ItineraryBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ItineraryBlockMobile.vue'),
    },
    [BLOCK_TYPES.VIDEO]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/VideoBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/VideoBlockMobile.vue'),
    },
    [BLOCK_TYPES.IMAGES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ImagesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ImagesBlockMobile.vue'),
    },
    [BLOCK_TYPES.TERMS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/TermsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/TermsBlockMobile.vue'),
    },
    [BLOCK_TYPES.PAYMENTS]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/PaymentsInfoBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/PaymentsInfoBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.IMAGES_AND_TEXT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ImagesAndTextDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ImagesAndTextMobile.vue'),
    },
    [BLOCK_TYPES.SPONSORS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SponsorsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SponsorsBlockMobile.vue'),
    },
    [BLOCK_TYPES.FILES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/FilesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/FilesBlockMobile.vue'),
    },
    [BLOCK_TYPES.ACCOMMODATIONS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/AccommodationsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/AccommodationsBlockMobile.vue'),
    },
    [BLOCK_TYPES.ARTISTS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ArtistsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ArtistsBlockMobile.vue'),
    },
    [BLOCK_TYPES.ATTENDEES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/AttendeesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/AttendeesBlockMobile.vue'),
    },
    [BLOCK_TYPES.BANNER]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/BannerBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/BannerBlockMobile.vue'),
    },
    [BLOCK_TYPES.GROUPINGS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/AgrupacionesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/AgrupacionesBlockMobile.vue'),
    },
    [BLOCK_TYPES.CONTACT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ContactBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ContactBlockMobile.vue'),
    },
    [BLOCK_TYPES.SOCIAL_MEDIA]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SocialMediaBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SocialMediaBlockMobile.vue'),
    },
    [BLOCK_TYPES.INDEX]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/IndexBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/IndexBlockMobile.vue'),
    },
    [BLOCK_TYPES.COUNTDOWN]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/CountdownBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/CountdownBlockMobile.vue'),
    },
    [BLOCK_TYPES.FAQ]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/FaqBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/FaqBlockMobile.vue'),
    },
    [BLOCK_TYPES.CALENDAR]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/CalendarBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/CalendarBlockMobile.vue'),
    },
    [BLOCK_TYPES.SEPARATOR]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SeparatorBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SeparatorBlockMobile.vue'),
    },
    [BLOCK_TYPES.FLIGHTS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/FlightsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/FlightsBlockMobile.vue'),
    },
  };

  const componentConfig = blockComponents[tipo];
  if (!componentConfig) return null;

  const deviceConfig = componentConfig[dispositivo];
  if (!deviceConfig) return null;

  const component = typeof deviceConfig === 'object' ? deviceConfig[entityType] : deviceConfig;
  if (!component) return null;

  const asyncComponent = defineAsyncComponent(component);
  asyncBlockComponentCache.set(cacheKey, asyncComponent);
  return asyncComponent;
}

const INDEX_EXCLUDED_BLOCK_TYPES = [BLOCK_TYPES.SEPARATOR];

export function hasBlockTitle(builder) {
  return Boolean(getNombreBlock(builder)?.trim());
}

export function getIndexBuilders(builders) {
  return builders.filter(builder => !INDEX_EXCLUDED_BLOCK_TYPES.includes(builder.tipo) && hasBlockTitle(builder));
}

export function sortBlocksByOrder(blocks) {
  const visibleBlocks = blocks.filter(block => block.visible === true);
  return visibleBlocks.sort((a, b) => a.order - b.order);
}

export const PDF_FORCED_DESIGN = {
  [BLOCK_TYPES.IMAGES]: DESIGN_A,
  [BLOCK_TYPES.ARTISTS]: DESIGN_B,
  [BLOCK_TYPES.IMAGES_AND_TEXT]: DESIGN_A,
  [BLOCK_TYPES.ITINERARY]: DESIGN_A,
  [BLOCK_TYPES.SPONSORS]: DESIGN_B,
  [BLOCK_TYPES.TERMS]: DESIGN_A,
};

export function getBlockWithForcedDesign(block) {
  const forcedDesignBlock = PDF_FORCED_DESIGN[block.tipo];
  if (forcedDesignBlock) {
    return { ...block, design: forcedDesignBlock };
  }
  return block;
}

export function backgroundColorToCss(backgroundColor) {
  if (!backgroundColor) return null;
  const hex = String(backgroundColor).replace('#', '').trim();
  if (hex.length !== 8 || !/^[0-9A-Fa-f]{8}$/.test(hex)) return null;
  return `#${hex.toUpperCase()}`;
}
